export const PARTNER_RECEIVED = 'PARTNER_RECEIVED';
export const PARTNER_CLEARED = 'PARTNER_CLEARED';
export const PARTNER_COMMENTS_RECEIVED = 'PARTNER_COMMENTS_RECEIVED';

export function partnerReceived(partner) {
    return {
        type: PARTNER_RECEIVED,
        partner
    };
}

export function partnerCleared() {
    return {
        type: PARTNER_CLEARED
    }
}

export function partnerCommentsReceived(comments, totalComments) {
    return {
        type: PARTNER_COMMENTS_RECEIVED,
        comments,
        totalComments
    }
}



// WEBPACK FOOTER //
// ./src/store/partner/actions.js